import HeartSimpleIcon from 'components/icons/heart-simple';

export const LoggedOutEmptyStateImage = HeartSimpleIcon;
